import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import SwiftTransactionResultPanel from "./SwiftTransactionResultPanel";

export default function SwiftTransactionPanel() {
    function mainComponent() {
        return <SwiftTransactionResultPanel/>;
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {mainComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}